import React, { useRef } from 'react';
import { Banner } from 'hfs-common-ui';
import { useTranslation } from 'react-i18next';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';
import { appInfo } from '~/config/app';
import { StatusMode } from '~/core/components/incident-communication/models/AppStatusConfig';
import { useIncidentBanner } from '~/core/components/incident-communication/hooks/use-incident-banner';
import useMeasuredTopBannerRegistration from '~/hooks/use-measured-top-banner-registration';
import * as S from './styled';

export interface Props {
  statusMode: StatusMode.GlobalMaintenanceBanner | StatusMode.SecuredMaintenanceBanner;
}

const IncidentBanner = ({ statusMode }: Props) => {
  const { showBanner, config, dismiss } = useIncidentBanner(statusMode);
  const wrapperRef = useRef<HTMLDivElement>(null);
  useMeasuredTopBannerRegistration(wrapperRef, showBanner);
  const { t } = useTranslation([InternationalizationNameSpace.IncidentCommunication]);

  if (!showBanner) {
    return null;
  }

  const icon =
    config.bannerSeverity === 'WARNING' ? 'notification.warning' : 'notification.info_outlined';

  return (
    <S.BannerWrapperDiv ref={wrapperRef}>
      <Banner
        bannerMessage={t(`incidentCommunication.banner.${config.bannerMessage}.message`, {
          name: appInfo.appName,
        })}
        bannerSeverity={config.bannerSeverity}
        icon={icon}
        onClose={dismiss}
      />
    </S.BannerWrapperDiv>
  );
};

export default IncidentBanner;
